import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { enableScroll, disableScroll } from '../../shared/scroll';
import styles from './Modal.css';

const cx = classnames.bind(styles);

function Modal({ onCloseModal, children, className, overlayClassName }) {
    const dialogRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    const classes = cx({
        modalContent: true,
        [className]: Boolean(className)
    });

    const closeModal = () => {
        dialogRef.current.close();
        setIsVisible(false);
    };

    const handleClose = () => {
        onCloseModal?.();
        closeModal();
    };

    const handleDialogClick = (e) => e.target === dialogRef.current && handleClose();

    const handleCancel = (e) => {
        e.preventDefault();
        handleClose();
    };

    useEffect(() => {
        dialogRef.current.showModal();
        disableScroll();
        requestAnimationFrame(() => setIsVisible(true));

        return () => {
            enableScroll();
        };
    }, []);

    return (
        <dialog
            ref={dialogRef}
            className={cx('dialog', overlayClassName, { visible: isVisible })}
            onClick={handleDialogClick}
            onCancel={handleCancel}
        >
            <div className={classes}>
                {children}
            </div>
        </dialog>
    );
}

Modal.defaultProps = {
    onCloseModal: null,
    overlayClassName: ''
};

Modal.propTypes = {
    onCloseModal: PropTypes.func,
    children: PropTypes.any.isRequired,
    className: PropTypes.string,
    overlayClassName: PropTypes.string
};

export { Modal };
